const $showInfo = $('section.show-information');

$('article .continue-indicator a').click(function (e) {
    if ($(this).attr('href') === '#') {
        e.preventDefault();

        var $this = $(this);
        var $parent = $this.parents('.article-hero');
        var $next = $parent.next('*');
        let offset = 100;

        if ($next.length > 0) {
            $('html, body').animate({
                scrollTop: $next.offset().top - offset
            }, 400);
        }
    }
});

function setColumns() {
    if($(window).width() >= 1920) {
        const $column1 = $showInfo.find('.list-wrapper li.xlarge-column-1');
        const $column2 = $showInfo.find('.list-wrapper li.xlarge-column-2');
        const $column3 = $showInfo.find('.list-wrapper li.xlarge-column-3');
        const $column4 = $showInfo.find('.list-wrapper li.xlarge-column-4');
        $column1.wrapAll('<ul class="xlarge-items-column-1"></ul>');
        $column2.wrapAll('<ul class="xlarge-items-column-2"></ul>');
        $column3.wrapAll('<ul class="xlarge-items-column-3"></ul>');
        $column4.wrapAll('<ul class="xlarge-items-column-4"></ul>');
    }
    else if($(window).width() >= 1440) {
        const $column1 = $showInfo.find('.list-wrapper li.item-column-1');
        const $column2 = $showInfo.find('.list-wrapper li.item-column-2');
        const $column3 = $showInfo.find('.list-wrapper li.item-column-3');
        $column1.wrapAll('<ul class="items-column-1"></ul>');
        $column2.wrapAll('<ul class="items-column-2"></ul>');
        $column3.wrapAll('<ul class="items-column-3"></ul>');
    }
    else if($(window).width() >= 768) {
        const $oddItems =  $showInfo.find('.list-wrapper li.item-odd');
        const $evenItems = $showInfo.find('.list-wrapper li.item-even');
        $oddItems.wrapAll('<ul class="odd-items"></ul>');
        $evenItems.wrapAll('<ul class="even-items"></ul>');
    }
    else {
        const $allItems = $showInfo.find('.list-wrapper li');
        $allItems.wrapAll('<ul></ul>');
    }
}
if($showInfo.length > 0 ) {
    setColumns();

    $(window).resize(function() {
        if($('.xlarge-items-column-1').length > 0) {
            const $column1 = $showInfo.find('.list-wrapper li.xlarge-column-1');
            const $column2 = $showInfo.find('.list-wrapper li.xlarge-column-2');
            const $column3 = $showInfo.find('.list-wrapper li.xlarge-column-3');
            const $column4 = $showInfo.find('.list-wrapper li.xlarge-column-4');
            $column1.unwrap();
            $column2.unwrap();
            $column3.unwrap();
            $column4.unwrap();
        }
        else if($('.items-column-1').length > 0) {
            const $column1 = $showInfo.find('.list-wrapper li.item-column-1');
            const $column2 = $showInfo.find('.list-wrapper li.item-column-2');
            const $column3 = $showInfo.find('.list-wrapper li.item-column-3');
            $column1.unwrap()
            $column2.unwrap();
            $column3.unwrap();
        }
        else if($('.odd-items').length > 0) {
            const $oddItems =  $showInfo.find('.list-wrapper li.item-odd');
            const $evenItems = $showInfo.find('.list-wrapper li.item-even');
            $oddItems.unwrap();
            $evenItems.unwrap();
        }
        else {
            const $allItems = $showInfo.find('.list-wrapper li');
            $allItems.unwrap();
        }
        setColumns();
    });

    if($('body').hasClass('single-actor')) {
        let $moreButton = $showInfo.find('a.show-more');
        let hiddenShows = $showInfo.find('ul li.hide');

        $moreButton.click(function(e) {
            e.preventDefault();
            hiddenShows.removeClass('hide');
            $moreButton.addClass('hide');
        });
    }
}